var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 33.5H2C1.60218 33.5 1.22064 33.342 0.93934 33.0607C0.658036 32.7794 0.5 32.3978 0.5 32V2C0.5 1.60218 0.658036 1.22064 0.93934 0.93934C1.22064 0.658036 1.60218 0.5 2 0.5H6.5C6.89782 0.5 7.27936 0.658036 7.56066 0.93934C7.84196 1.22064 8 1.60218 8 2V32C8 32.3978 7.84196 32.7794 7.56066 33.0607C7.27936 33.342 6.89782 33.5 6.5 33.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33.5H15.5C15.1022 33.5 14.7206 33.342 14.4393 33.0607C14.158 32.7794 14 32.3978 14 32V2C14 1.60218 14.158 1.22064 14.4393 0.93934C14.7206 0.658036 15.1022 0.5 15.5 0.5H20C20.3978 0.5 20.7794 0.658036 21.0607 0.93934C21.342 1.22064 21.5 1.60218 21.5 2V32C21.5 32.3978 21.342 32.7794 21.0607 33.0607C20.7794 33.342 20.3978 33.5 20 33.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.f23b18e0f3955f5b3288b450312f4311.svg";
export { ForwardRef as ReactComponent };